"use strict";

exports.__esModule = true;
exports.TreeViewHeader = TreeViewHeader;
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function TreeViewHeader() {
  return /*#__PURE__*/_react["default"].createElement(_Core.Heading, {
    level: "1",
    ellipsize: true
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "TreeViewHeader.headingLabel",
    defaultMessage: "Tree View"
  }));
}